import { helpers } from '../helpers.js';

var currencySwitcherWooCommerce = {
	options: {
		// global options
	},

	selectors: {
		"switcher": ".js-currency-switcher-woocommerce",
	},

	init: function () {
		const self = this;

		jQuery(self.selectors.switcher).on('change', function () {
			const currency = jQuery(this).val();
			let url = new URL(window.location.href);
			url.searchParams.set("change_currency_to", currency);
			window.location.href = url;
		});
	},
}

// Export
export { currencySwitcherWooCommerce };